import { ConfirmModal } from '../../../shared/modal'

type ConfirmClearPlanModalProps = {
  /** Determines visibility of modal */
  isOpen: boolean
  /** Event callback when Confirm Button is triggered */
  onConfirm: () => void
}

const ConfirmClearPlanModal = ({ isOpen, onConfirm }: ConfirmClearPlanModalProps) => (
  <ConfirmModal
    confirmText="Clear"
    isOpen={isOpen}
    onConfirm={onConfirm}
    title="Clear Items in Plan"
  >
    Are you sure you want to clear items in this plan? This cannot be undone. Required and locked
    items cannot be cleared.
  </ConfirmModal>
)

export default ConfirmClearPlanModal
